export const parseNum = (v: string): number | null => (v === '' ? null : Number(v));
